import Add from './add.vue'

export default [{
    path: '/:type',
    name:'roleAdd',
    component:Add,
}]